module.exports = __webpack_public_path__ + "static/zama_pez_sintesis-1ab57ef7b7dfa56f713eef248330d7ef.jpg";